import React from "react";
import { Link } from "react-router-dom";
import "../../styles/Navbar.css";

const scrollToTop = () => {
  window.scrollTo(0, 0);
};

const Navbar = () => {
  return (
    <nav className="navbar">
      <Link to="/" className="navbar-logo" onClick={scrollToTop}>BIIYEON</Link>
      <div className="navbar-menu">
        <Link to="/aura" className="navbar-link" onClick={scrollToTop}>Aura</Link>
        <Link to="/work" className="navbar-link" onClick={scrollToTop}>Work</Link>
        <Link to="/contact" className="navbar-link" onClick={scrollToTop}>Contact</Link>
      </div>
    </nav>
  );
};

export default Navbar;
